import { ThemeVariables } from '@/interfaces/theme';

import palette from '../default/palette';

const variables = {
  bgElevated: palette.gray[10],
  bgComponentsContainer: palette.gray[9],

  hoverBackground: palette.alpha(palette.gray[12], 0.2),

  dividerColor: palette.alpha(palette.gray[0], 0.12),
  borderColor: palette.gray[8],

  shadowEffect: palette.gray[11],

  audioPlayerBackground: palette.alpha(palette.gray[0], 0.12),

  imageRatio: {
    background: palette.gray[8],
    iconColor: palette.gray[9]
  },

  tabs: {
    headerBackground: palette.gray[9],
    contentBackground: palette.gray[10]
  },

  resumeOfferButton: {
    background: palette.alpha(palette.gray[12], 0.45),
    color: palette.alpha(palette.gray[0], 0.65),
    border: palette.alpha(palette.gray[0], 0.65)
  },

  resumeSeeMoreButton: {
    background: palette.gray[0],
    color: palette.gray[12],
    border: palette.gray[0]
  },

  courseModuleCheck: {
    background: palette.gray[0],
    color: palette.gray[12]
  },

  contentButtonWatchLesson: {
    background: palette.gray[0],
    color: palette.gray[12]
  },

  courseAuthorBorder: palette.alpha(palette.gray[0], 0.15),

  courseButtonWatchLesson: palette.gray[8],

  contentDownloadFileButton: {
    background: palette.alpha(palette.gray[0], 0.08)
  },

  contentCertificateButton: {
    background: palette.alpha(palette.gray[0], 0.08)
  },

  contentButtonSaveLesson: {
    border: palette.alpha(palette.gray[0], 0.45),
    background: palette.alpha(palette.gray[12], 0.45),
    color: palette.alpha(palette.gray[0], 0.45),

    hover: {
      background: palette.alpha(palette.gray[12], 0.85),
      color: palette.alpha(palette.gray[0], 0.85)
    }
  },

  myCoursesCardButtonText: palette.alpha(palette.gray[12], 0.8),

  notesPreview: {
    background: palette.alpha(palette.gray[0], 0.2),
    border: palette.alpha(palette.gray[0], 0.12)
  },
  integrationButton: {
    text: palette.gray[0],
    background: palette.gray[12],
    border: 'transparent'
  },

  pageBackgroundGradient: palette.alpha(palette.gray[12], 0.85),
  bgGradient: palette.gray[11]
} as Partial<ThemeVariables>;

export default variables;
